import compact from 'lodash/compact'
import join from 'lodash/join'
import keyBy from 'lodash/keyBy'
import map from 'lodash/map'

import { CartContentFragment } from '@Generated/graphql'
import { isFirstVisitOver } from '@Globals/Device'
import { getSplitTestsHistory } from '@Globals/SplitTests/History'

export const isLandingPage = isFirstVisitOver()

const urlParameters = new Map([
  ['att_ad_group_id', 'attribution_ad_group_id'],
  ['att_ad_id', 'attribution_ad_id'],
  ['att_campaign_id', 'attribution_campaign_id'],
  ['att_category', 'attribution_category'],
  ['att_criteria_id', 'attribution_criteria_id'],
  ['att_network', 'attribution_network'],
  ['att_placement_category', 'attribution_placement_category'],
  ['att_placement', 'attribution_placement'],
  ['att_searchtype', 'attribution_searchtype'],
  ['att_type', 'attribution_type'],
  ['gclid', 'attribution_gclid'],
  ['utm_campaign', 'attribution_utm_campaign'],
  ['utm_content', 'attribution_utm_content'],
  ['utm_medium', 'attribution_utm_medium'],
  ['utm_source', 'attribution_utm_source'],
  ['utm_term', 'attribution_utm_term'],
])

export function getAttributionUserAttributes() {
  let shouldUpdate = false
  const urlParams = new URLSearchParams(window.location.search)
  const userAttributes: Record<string, string> = {}

  urlParameters.forEach((userAttribute, urlParameter) => {
    userAttributes[userAttribute] = '-'

    if (urlParams.has(urlParameter)) {
      shouldUpdate = true
      userAttributes[userAttribute] = urlParams.get(urlParameter) || '-'
    }
  })

  if (!shouldUpdate) {
    return {}
  }

  return userAttributes
}

function getGroupedReferrer(domain: string) {
  switch (true) {
    case domain.includes('bing'): return 'bing'
    case domain.includes('doubleclick'): return 'google'
    case domain.includes('facebook'): return 'facebook'
    case domain.includes('google'): return 'google'
    case domain.includes('instagram'): return 'instagram'
    case domain.includes('pinterest'): return 'pinterest'
    case domain.includes('youtube'): return 'youtube'
    default: return ''
  }
}

export function getReferrerAttributes() {
  if (isLandingPage && document.referrer) {
    const domain = new URL(document.referrer).hostname

    return {
      referrer: document.referrer,
      referring_domain: domain,
      referring_domain_grouped: getGroupedReferrer(domain),
    }
  }

  return {
    referrer: '',
    referring_domain: '',
    referring_domain_grouped: '',
  }
}

export function getSplitTests() {
  return join(
    map(
      getSplitTestsHistory(),
      (value, key) => `${key}_${value?.group?.toUpperCase()}`,
    ),
    ',',
  )
}

export function getURLAttributes() {
  const searchParams = new URLSearchParams(window.location.search)

  return {
    gclid: searchParams.get('gclid') || '',
    utm_campaign: searchParams.get('utm_campaign') || '',
    utm_content: searchParams.get('utm_content') || '',
    utm_medium: searchParams.get('utm_medium') || '',
    utm_source: searchParams.get('utm_source') || '',
    utm_term: searchParams.get('utm_term') || '',
  }
}

export function recoverableCartProducts(cart: CartContentFragment | null | undefined) {
  const lineItemIDs = keyBy(cart?.lineItems || [], 'id')
  return compact(cart?.recoverableLineItemIDs?.map((id) => {
    if (!lineItemIDs[id]) {
      return null
    }
    return { quantity: lineItemIDs[id].quantity || 1, productID: lineItemIDs[id].product?.id || '', variantID: lineItemIDs[id].variant?.id || '' }
  }))
}
